import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import notify from "devextreme/ui/notify";

@Injectable({
  providedIn: 'root'
})
export class ToastService extends BaseService {
  /**
   * Undefined duration of snackbar
   */
  private readonly UNDEFINED_SNACKBAR_DURATION = undefined;
  /**
   * Long duration of snackbar
   */
  private readonly LONG_SNACKBAR_DURATION = 1036800000;
  /**
   * 5 sec duration of snackbar
   */
  private readonly FIVE_SECONDS_SNACKBAR_DURATION = 5000;
  /**
   * 2 sec duration of snackbar
   */
  private readonly TWO_SECONDS_SNACKBAR_DURATION = 2000;
  // ****************************
  //      SNACKBAR PARAMS
  public messageVisible = false;
  public messageText: string = "";
  public messageDisplayTime: number = 0;
  // ****************************
  /**
   * Default snackbar options
   */
  private readonly SNACKBAR_OPTIONS = {
    closeOnClick: true,
    hideOnOutsideClick: true,
    message: "",
    type: "info",
    displayTime: this.FIVE_SECONDS_SNACKBAR_DURATION
  };


  /**
   * The method opens a snackBar with success message and style.
   * The default duration is 2 seconds
   * The default position is bottom-centered
   * @param messageID the message to display
   */
  public openTranslatedSuccessToastMessage(messageID: string): void {
    this.translate.get(messageID).subscribe(
      translation => {
        this.openSuccessToastMessage(translation);
      },
      error1 => {
        console.log(error1);
        this.openSuccessToastMessage(messageID);
      });
  }

  public openSuccessToastMessage(message: string): void {
    // Clone options to avoid modifying the original
    let messageOptions = {...this.SNACKBAR_OPTIONS};
    messageOptions.message = message;
    messageOptions.type = 'success';
    messageOptions.displayTime = this.TWO_SECONDS_SNACKBAR_DURATION;

    // Display toast and set up auto-decrement of counter when toast is dismissed
    notify(messageOptions, {position: "bottom center", direction: "up-push"});
  }

  /**
   * The method opens a snackBar with error message and style.
   * The default duration is undefined
   * The default position is bottom-centered
   * @param errorID the error to display
   */
  public openTranslatedErrorToastMessage(errorID: string): void {
    try {

      this.translate.get(errorID).subscribe(
        translation => {
          this.openErrorToastMessage(translation);
        },
        error1 => {
          console.log(error1);
          this.openErrorToastMessage(errorID);
        });
    } catch (error) {
      console.log(error);
      this.openErrorToastMessage(errorID);
    }
  }

  public openTranslatedInfoToastMessage(messageID: string): void {
    this.translate.get(messageID).subscribe(
      translation => this.openInfoToastMessage(translation),
      () => this.openInfoToastMessage(messageID)
    );
  }

  public openInfoToastMessage(msg: string): void {
    // Clone options to avoid modifying the original
    let messageOptions = {...this.SNACKBAR_OPTIONS};
    messageOptions.message = msg;
    messageOptions.type = 'info';
    messageOptions.displayTime = this.FIVE_SECONDS_SNACKBAR_DURATION;

    // Display toast and set up auto-decrement of counter when toast is dismissed
    notify(messageOptions, {position: "bottom center", direction: "up-push"});
  }

  public openWarningToastMessage(msg: string): void {
    let messageOptions = {...this.SNACKBAR_OPTIONS};
    messageOptions.message = msg;
    messageOptions.type = 'warning';
    messageOptions.displayTime = this.FIVE_SECONDS_SNACKBAR_DURATION;
    notify(messageOptions, {position: "bottom center", direction: "up-push"});
  }

  public openErrorToastMessage(error1: string): void {
    console.error(error1);

    // Clone options to avoid modifying the original
    let messageOptions = {...this.SNACKBAR_OPTIONS,};
    messageOptions.message = error1;
    messageOptions.type = 'error';
    messageOptions.displayTime = this.LONG_SNACKBAR_DURATION;

    // Display toast and set up auto-decrement of counter when toast is dismissed
    notify(messageOptions, {position: "bottom center", direction: "up-push"});
  }

  public closeToastMessage(): void {
    this.messageVisible = false;
    this.messageText = '';
    this.messageDisplayTime = 0;
  }

  cleanupServiceFields(): void {
    this.closeToastMessage();
  }
}
